<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
      viewBox="0 0 24 24"
    >
      <path d="M13 11H17V13H13V17H11V13H7V11H11V7H13V11Z" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
      />
    </svg>
  </template>
  
  <script>
  export default {
    name: 'IconCirclePlus',
  };
  </script>
  
  <style scoped>
  .icon {
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    fill: inherit;
    flex-shrink: 0;
  }
  </style>
  